export default __webpack_public_path__ + "static/media/bg10.b73e23b8.png";